import { TCellComponent } from '../List';
import { Label } from 'semantic-ui-react';

// collective.solr 10 leaves an empty field out of the Solr document,
// then interaktiv.solr sends '' instead of a list
const TypesCellContent: TCellComponent<string[] | string> = ({ data }) => (
  <>
    {(Array.isArray(data) ? data : []).map((type, idx) => (
      <Label key={idx}>{type}</Label>
    ))}
  </>
);

export default TypesCellContent;
